import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateContext, ContextListElem, Context, AdminContextListElem, ContextDetail } from '../models/context.model';
import { environment } from '../../../environments/environment';
import { ResponseStatus } from '../../shared/models/response-status.model';
import { Domains } from '../models/domains.model';

@Injectable({
  providedIn: 'root'
})
export class ContextService {
  constructor(private readonly http: HttpClient) { }

  createContext(context: CreateContext) {
    return this.http.post<Context>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts`, context);
  }

  updateContext(context: CreateContext, contextId: string) {
    return this.http.put<Context>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}`, context);
  }

  listContext() {
    return this.http.get<ContextListElem[]>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts`);
  }

  getContextDetail(contextId: string) {
    return this.http.get<ContextDetail>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}`);
  }

  toggleGroupToContext(contextId: string, action: { action: 'add' | 'remove', groupId: string }) {
    return this.http.post<ResponseStatus>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}/group`, action);
  }

  // ROLE_ADM
  listMyContexts(adminId: string) {
    return this.http.get<AdminContextListElem[]>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/admin/${adminId}`);
  }

  deleteContext(contextId: string) {  
    return this.http.delete<ResponseStatus>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}`);
  }

  // - 🆕 `GET /contexts/{id}/domains` — lista domini abilitati del contesto
  getContextDomains(contextId: string) {
    return this.http.get<Domains>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}/domains`);
  }
  
  // - 🆕 `POST /contexts/{id}/domains` — aggiunge un dominio al contesto
  addContextDomain(contextId: string, domains: string[]) {
    return this.http.post<ResponseStatus>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}/domains`, { domains });
  }

  // - 🆕 `DELETE /contexts/{id}/domains` — rimuove un dominio dal contesto
  deleteContextDomain(contextId: string, domain: string) {
    return this.http.delete<ResponseStatus>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/${contextId}/domains/${domain}`);
  }
}
